/** Snapshot 7S modal (Buoc1 điểm mạnh) — EvaluatePage cập nhật trước khi Tra cứu AI. */

export type BscSevenSDocRow = {
  group: string;
  name: string;
  checked: boolean;
  content: string;
};

let sevenSDocuments: BscSevenSDocRow[] = [];

export function setB1SevenSDocumentsForAi(rows: BscSevenSDocRow[]) {
  sevenSDocuments = rows;
}

export function getB1SevenSDocumentsForAi(): BscSevenSDocRow[] {
  return sevenSDocuments;
}
